import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-gradient-to-r from-primary to-primary-hover text-primary-foreground hover:shadow-md hover:shadow-primary/20",
        secondary:
          "border-transparent bg-gradient-to-r from-secondary to-secondary-glow text-secondary-foreground hover:shadow-md hover:shadow-secondary/20",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/90 hover:shadow-md",
        outline: "text-foreground border-border/60 hover:bg-primary/10 hover:border-primary/40",
        premium: "border-transparent bg-gradient-to-r from-premium via-premium-glow to-premium text-accent-foreground font-bold shadow-[0_0_12px_hsla(25,95%,58%,0.5)]",
        vibrant: "border-transparent animate-premium-gradient text-accent-foreground font-bold",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => (
    <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
  )
)
Badge.displayName = "Badge"

export { Badge, badgeVariants }
